/* Maison Bona product-page reference enhancements. Product pages only. */
(() => {
  const extrasMarkup = `
    <div class="mb-purchase-extras" data-mb-purchase-extras>
      <div class="mb-purchase-points">
        <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2.8 16 6l5 .8-2.5 4.4.7 5-4.7 1.8L12 22l-2.5-4-4.7-1.8.7-5L3 6.8 8 6l4-3.2Z" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linejoin="round"/></svg>
        <span>Earn BONA Points with this purchase.</span>
      </div>
      <div class="mb-purchase-assurance" aria-label="Maison Bona service benefits">
        <div class="mb-purchase-assurance__item">
          <span class="mb-purchase-assurance__icon" aria-hidden="true">
            <svg viewBox="0 0 24 24"><path d="M4 9h16v11H4z"/><path d="M3 6h18v3H3zM12 6v14M12 6H8.8a2.3 2.3 0 1 1 2.3-2.3C11.1 5 12 6 12 6Zm0 0h3.2a2.3 2.3 0 1 0-2.3-2.3C12.9 5 12 6 12 6Z"/></svg>
          </span>
          <strong>COMPLIMENTARY GIFT</strong>
          <small>On eligible orders</small>
        </div>
        <div class="mb-purchase-assurance__item">
          <span class="mb-purchase-assurance__icon" aria-hidden="true">
            <svg viewBox="0 0 24 24"><rect x="3" y="5" width="18" height="14" rx="2"/><path d="M3 9h18M15.5 15h2.5"/></svg>
          </span>
          <strong>SECURE PAYMENT</strong>
          <small>Multiple options</small>
        </div>
        <div class="mb-purchase-assurance__item">
          <span class="mb-purchase-assurance__icon" aria-hidden="true">
            <svg viewBox="0 0 24 24"><path d="M3 6h11v10H3zM14 9h3.5l3.5 4v3h-7z"/><circle cx="7" cy="18" r="2"/><circle cx="18" cy="18" r="2"/></svg>
          </span>
          <strong>RELIABLE DELIVERY</strong>
          <small>Tracked dispatch</small>
        </div>
      </div>
    </div>`;

  const mountPurchaseExtras = () => {
    const main = document.querySelector('#MainContent[data-template^="product"]');
    if (!main) return;

    const buyBlock = main.querySelector('.product-details .buy-buttons-block');
    if (!buyBlock) return;

    let extras = main.querySelector('[data-mb-purchase-extras]');
    if (!extras) {
      const holder = document.createElement('div');
      holder.innerHTML = extrasMarkup.trim();
      extras = holder.firstElementChild;
      buyBlock.insertAdjacentElement('afterend', extras);
    } else if (extras.previousElementSibling !== buyBlock) {
      buyBlock.insertAdjacentElement('afterend', extras);
    }
  };

  const scheduleMount = () => {
    window.clearTimeout(window.__mbPdpReferenceTimer);
    window.__mbPdpReferenceTimer = window.setTimeout(mountPurchaseExtras, 40);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountPurchaseExtras, { once: true });
  } else {
    mountPurchaseExtras();
  }

  document.addEventListener('shopify:section:load', scheduleMount);
  document.addEventListener('shopify:section:select', scheduleMount);

  const main = document.querySelector('#MainContent[data-template^="product"]');
  if (main) {
    const observer = new MutationObserver(() => {
      if (!main.querySelector('[data-mb-purchase-extras]')) scheduleMount();
    });
    observer.observe(main, { childList: true, subtree: true });
  }
})();
